// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__Vih+p","main":"SecOne_main__rSfiS"};